export default {
    0: 'Payable on receipt',
    15: 'Net 15',
    30: 'Net 30',
    60: 'Net 60',
    90: 'Net 90'
};
